import { Loader2 } from "lucide-react";

const LoadingSpinner = () => {
  return (
    <output className="loading-spinner" aria-live="polite" aria-busy="true">
      <div className="loading-spinner__backdrop">
        <div className="loading-spinner__content">
          <Loader2 className="loading-spinner__icon" aria-hidden="true" />
          <span className="loading-spinner__label">Loading IntelliExtract Studio…</span>
        </div>
      </div>
    </output>
  );
};

export default LoadingSpinner;
